

import React from 'react';
import { Check } from 'lucide-react';

interface Step {
  stepNumber: number;
  label: string;
}

interface StepBarProps {
  steps: Step[];
  currentStep: number;
}

const StepBar: React.FC<StepBarProps> = ({ steps, currentStep }) => {
  return (
    <div className="w-full px-4 py-4">
      <div className="flex items-center justify-between relative">
        {steps.map((step, index) => {
          const isCompleted = step.stepNumber < currentStep;
          const isCurrent = step.stepNumber === currentStep;
          const isUpcoming = step.stepNumber > currentStep;

          return (
            <React.Fragment key={step.stepNumber}>
              {/* Step Item */}
              <div className="flex flex-col items-center relative z-10">
                {/* Circle */}
                <div
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center
                    transition-all duration-300 border-2
                    ${
                      isCompleted
                        ? 'bg-blue-500 border-blue-500 text-white'
                        : isCurrent
                        ? 'bg-blue-500 border-blue-500 text-white'
                        : 'bg-white border-gray-300 text-gray-400'
                    }
                  `}
                >
                  {isCompleted ? (
                    <Check className="w-5 h-5" />
                  ) : (
                    <span className="font-semibold">{step.stepNumber}</span>
                  )}
                </div>

                {/* Label */}
                <div
                  className={`
                    mt-3 text-sm font-medium whitespace-nowrap
                    ${
                      isCompleted || isCurrent
                        ? 'text-gray-900'
                        : 'text-gray-400'
                    }
                  `}
                >
                  {step.label}
                </div>
              </div>

              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="flex-1 relative" style={{ top: '-24px' }}>
                  <div className="h-0.5 bg-gray-200 w-full">
                    <div
                      className={`
                        h-full transition-all duration-300
                        ${
                          step.stepNumber < currentStep
                            ? 'bg-blue-500 w-full'
                            : 'bg-gray-200 w-0'
                        }
                      `}
                    />
                  </div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default StepBar